import * as Yup from 'yup';

export const defaultModelKeys = {
  name: "",
  instruction: "",
  description: "",
  options: [],
  topics: [],
  industrys: [],
  companies: [],
  organizations: [],
  members: [],
  diseases: [],
  countries: [],
  visibility: "all",
  stage_template_id: "",
};

export const newFordProject = {
  name: "",
  project_id: "",
  instruction: "",
  description: "",
  problem_statement: "",
  potential_benefits: "",
  topics: [],
  visibility: "all",
  stage_template_id: "",
  project_stage: "proposal_for_prototype",
  select_all_members: true,
  select_all_companies: true,
  selected_member_ids: [],
  selected_company_ids: [],
  isReplication: false,
  project_owners: [],
};

export const newFordProjectValidationStep1 = Yup.object().shape({
  name: Yup.string().required('Project name is required'),
  stage_template_id: Yup.string().required("Evaluation type is required"),
  selectedPlant: Yup.object().nullable().required("Plant is required"),
  project_owners: Yup.array().min(1, "Project Owner is required"),
});
